export enum LinkedRecordType {
 organisation = 1,
 user = 2,
 complaint = 3,
 contactAo = 4,
 eventNotification = 5,
 risk = 6,
 unit = 7,
 qualification = 8,
 apq = 9,
 ctr = 10,
 foi = 11,
 publicEnquiry = 12,
 sar = 13,
 Lcm = 14,
}

export const getLinkRecordTypeTitle = (type: LinkedRecordType) => {
 switch (type) {
  case LinkedRecordType.organisation:
   return 'Organisation';
  case LinkedRecordType.user:
   return 'User';
  case LinkedRecordType.complaint:
   return 'Complaint';
  case LinkedRecordType.contactAo:
   return 'Contact AO';
  case LinkedRecordType.eventNotification:
   return 'Event Notification';
  case LinkedRecordType.risk:
   return 'Risk';
  case LinkedRecordType.unit:
   return 'Units';
  case LinkedRecordType.qualification:
   return 'Qualifications';
  case LinkedRecordType.apq:
   return 'APQs';
  case LinkedRecordType.ctr:
   return 'CTRs';
  case LinkedRecordType.foi:
   return 'FOIs';
  case LinkedRecordType.publicEnquiry:
   return 'Public Enquiries';
  case LinkedRecordType.sar:
   return 'SARs';
  case LinkedRecordType.Lcm:
   return 'LCMs';
  default:
   return LinkedRecordType[type];
 }
};
